import * as React from "react";

export const ProjectBigIcon = ({ color }: { color: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="23" fill="none" viewBox="0 0 21 23">
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
      d="M2.889 4h3.778L9.5 6.833h6.611A1.89 1.89 0 0 1 18 8.723v7.555a1.89 1.89 0 0 1-1.889 1.889H2.89A1.89 1.89 0 0 1 1 16.277V5.89A1.89 1.89 0 0 1 2.889 4"
    ></path>
    <path stroke={color} strokeWidth="1.417" d="M12.333 6.974H1"></path>
  </svg>
);
